import { DvirFormState } from '../types';

export const dvirFormState: DvirFormState = {
  totalRecords: 0,
  dvirForms: [],
  createUpdateDvirFormModal: {
    visible: false,
    dvirForm: null,
    method: null,
  },
};
